module.exports = [{"text":"Search appointment","url":"healthcarebook_searchappointment","preview":"healthcarebook/container.png"},{"text":"Components","url":"healthcarebook_components","preview":"healthcarebook/components.png"},{"text":"Responsive","url":"healthcarebook_responsive","preview":"healthcarebook/responsive.png"},{"text":"Language","url":"healthcarebook_language","preview":"healthcarebook/lang.png"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/menu.json
// module id = 339
// module chunks = 0